import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { PageLayout } from '../components/layout/PageLayout';
import { apiFetch, uploadFile } from '../lib/api-client';
import { useToast } from '../components/ui/toast';

export function RespondInfo() {
  const { leaveId } = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm<{ response_text: string }>();
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  async function onSubmit(data: { response_text: string }) {
    setLoading(true);
    try {
      let evidence_path: string | undefined;
      if (file) evidence_path = await uploadFile(file, 'evidence');
      await apiFetch('/leave/respond-info', {
        method: 'POST',
        body: { leave_id: leaveId, response_text: data.response_text, evidence_path },
      });
      toast.success('ส่งข้อมูลเพิ่มเติมแล้ว');
      navigate('/');
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'เกิดข้อผิดพลาด');
    } finally { setLoading(false); }
  }

  return (
    <PageLayout title="ตอบกลับขอข้อมูลเพิ่ม">
      <p className="text-sm text-gray-600 mb-3">ใบลา: <span className="font-mono">{leaveId}</span></p>
      <form onSubmit={handleSubmit(onSubmit)} className="card p-4 space-y-4">
        <div>
          <label className="label">ข้อมูลเพิ่มเติม</label>
          <textarea {...register('response_text', { required: true })} rows={4} className="input" />
        </div>
        <div>
          <label className="label">หลักฐาน (ถ้ามี)</label>
          <input type="file" accept="image/*,application/pdf" onChange={(e) => setFile(e.target.files?.[0] ?? null)} className="input" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? 'กำลังส่ง...' : 'ส่งคำตอบ'}
        </button>
      </form>
    </PageLayout>
  );
}
